export default {
  consultTypeEnum: {
    0: '图文咨询',
    1: '视频咨询',
    2: '电话咨询'
  },
  // html普通会话
  HTML_MESSAGES: ['50500', '50503', '53001'],

  //允许发送图片格式
  IMG_TYPE: {
    jpg: 1,
    png: 1,
    jpeg: 1
  },
  //系统消息集合
  SYSTEM_MESSAGES: [
    '25008',
    '29007',
    '50004',
    '50012',
    '50015',
    '50016',
    '50100',
    '50101',
    '50200',
    '50201',
    '50203',
    '50300',
    '50301',
    '50302',
    '50303',
    '50304',
    '50400',
    '50502',
    '50601',
    '50602',
    '50603',
    '50604',
    '50605',
    '50606',
    '50701',
    '50017',
    '50018',
    '50019'
  ],
  //处理中工单群聊消息缩略语
  CHAT_MESSAGE_TYPE: {
    50101: '[问诊提醒]',
    24000: '医生已发起付费问诊，等待患者支付，未支付时患者无法发送消息',
    24001: '[问诊开始]',
    24002: '已退费',
    24100: '[问诊取消]',
    25001: '[问诊开始]',
    25002: '[问诊结束]',
    // 25003 不需要现实默认的内容从服务端获取
    // 25003: '当前问诊已结束',
    25006: '当前付费问诊未响应',
    50002: '患者已发起付费问诊，进入待付款状态，未支付时患者无法发送消息。',
    50003: '[问诊取消]',
    50005: '患者已支付诊费，等待医生接诊',
    50006: '患者支付诊费，但医生还未接诊，剩余1小时有效期，请提醒医生尽快接诊',
    50007: '患者发起了问诊，但医生还未接诊，剩余1小时有效期，请提醒医生尽快接诊',
    50008: '问诊已开始，但医生1小时内未响应，请提醒医生及时沟通',
    50009: '问诊已开始，但医生1小时未响应，请提醒医生及时沟通',
    50010: '[问诊取消]',
    50011: '医生无操作，已自动拒绝接诊，问诊费已自动退回。',
    50012: '[问诊开始]',
    50013: '医生接诊后无回复，问诊已关闭。',
    50014: '医生接诊后无回复，问诊已关闭，问诊费将自动退回。',
    50015: '医生在忙未接诊，问诊已关闭。医生已设置{问诊时间}的问诊提醒',
    50016: '医生在忙未接诊，问诊费将自动退回。',
    50100: '[问诊提醒]',
    50200: '患者已发起付费问诊，进入待付款状态，未付款时患者无法发送消息',
    21003: '[线上病历]',
    21001: '[病情咨询]',
    21002: '[门诊病历]',
    22011: '中药处方待审核',
    22012: '西药处方待审核',
    22001: '[中药处方]',
    22021: '处方审核未通过',
    22002: '[西药处方]',
    22022: '处方审核未通过',
    22003: '[健康辅助方]',
    22006: '患者发起续方申请，请提醒医生处理',
    22005: '医生不同意续方申请',
    22110: '处方',
    22111: '处方',
    22112: '处方审核未通过',
    29101: '[锦旗]',
    29005: '[沟通小结]',
    23001: '[随访量表]',
    23002: '[随访量表]',
    23008: '[随访量表]',
    23003: '[随访结果]',
    23004: '[指导意见]',
    23005: '[随访量表]',
    23006: '[复诊提醒]',
    23007: '[复诊提醒结果]',
    29003: '[复诊预约]',
    29004: '[复诊预约结果]',
    29006: '[复诊预约取消]', //'[取消预约通知]'
    27002: '[检查单]',
    27003: '[检查单结果]',
    50201: '系统提醒：患者消息未回复，请尽快处理',
    50203: '系统提醒：医生消息未回复，请尽快处理',
    22113: '[用药建议]',
    29800: '[群发消息]'
  },
  //处理中工单群聊消息缩略语(取后端返回的文案)
  CHAT_MESSAGE_TXT: ['50004', '25008'],
  //会话中系统消息对应文本
  TIPS_MESSAGE_TYPE: {
    22006: '患者发起续方申请，请提醒医生处理。',
    22011: '中药处方待审核',
    22012: '西药处方待审核',
    22021: '处方审核未通过',
    22022: '处方审核未通过',
    // 22111: '处方待审核',
    22112: '处方审核未通过',
    24000: '医生已发起付费问诊，等待患者支付，未支付时患者无法发送消息',
    24001: '患者和医生的问诊已经建立，请根据实际情况做好您的服务',
    24002: '已退费',
    24100: '患者未支付，当前问诊已自动取消',
    25002: '当前问诊已结束',
    // 25003 不需要现实默认的内容从服务端获取
    // 25003: '当前问诊已结束',
    25006: '当前付费问诊未响应',
    50002: '患者已发起付费问诊，进入待付款状态，未付款时患者无法发送消息。',
    50003: '患者未支付，当前问诊已自动取消',
    50005: '患者已支付诊费，等待医生接诊。',
    50006: '患者支付诊费，但医生还未接诊，剩余1小时有效期，请提醒医生尽快接诊', //医生未接诊（患者付费）后，47小时内未接诊
    50007: '患者发起了问诊，但医生还未接诊，剩余1小时有效期，请提醒医生尽快接诊', //医生未接诊（免费）后，47小时内未接诊
    50008: '问诊已开始，但医生1小时内未响应，请提醒医生及时沟通',
    50009: '问诊已开始，但医生1小时未响应，请提醒医生及时沟通',
    50010: '医生无操作，已自动拒绝接诊',
    50011: '医生无操作，已自动拒绝接诊，问诊费已自动退回。',
    50012: '患者和医生的问诊已经建立，请根据实际情况做好您的服务',
    50013: '医生接诊后无回复，问诊已关闭。',
    50014: '医生接诊后无回复，问诊已关闭，问诊费已自动退回。'
  },
  //性别枚举
  GENDER: {
    0: '女',
    1: '男',
    2: '未知'
  },
  //屏蔽某类型消息
  SHIELD_MSG: ['24003', '25007', '50202', '21004', '50551', '50204', '50022'],
  //系统消息角色
  SYSTEM_SOLE: /^[a-zA-Z]+$/,
  //悬浮工单类型集合
  FLOAT_WORK_ORDER: {
    39: '', //需求跟踪
    24: '医生/患者不同意复诊日期', // 复诊不同意工单
    27: '患者发生复诊行为，请确认是否复诊。', // 有效扫码工单
    //10: '', //'导诊咨询',

    22: 'AI智能体已生成与患者沟通的小结。', // 复诊跟踪工单
    23: 'AI智能体已生成与患者沟通的小结。', // 待添加复诊日期工单
    25: 'AI智能体已生成与患者沟通的小结。', // 复诊未确认工单
    26: 'AI智能体已生成与患者沟通的小结。', // 补充诊疗记录工单
    1: 'AI智能体已生成与患者沟通的小结。', //'私聊工单',
    5: 'AI智能体已生成与患者沟通的小结。', // 代购
    33: 'AI智能体已生成与患者沟通的小结。', //'复诊提醒',
    32: 'AI智能体已生成与患者沟通的小结。', //'疗效跟踪',
    38: 'AI智能体已生成与患者沟通的小结。' //'疗效反馈',
    // 以前的版本
    // 1: '',
    // 22: '患者复诊日期已过未复诊，请协助患者复诊', // 复诊跟踪工单
    // 23: '患者添加诊疗记录，', // 待添加复诊日期工单
    // 24: '医生/患者不同意复诊日期', // 复诊不同意工单
    // 25: '医生/患者未确认复诊日期', // 复诊未确认工单
    // 26: '请为患者补充诊疗记录。', // 补充诊疗记录工单
    // 27: '患者发生复诊行为，请确认是否复诊。', // 有效扫码工单
    // 39: ''
  },
  //预约状态合集
  RESERCE_STATE_MAP: {
    0: '待医生确认',
    1: '已就诊',
    2: '已取消',
    3: '待就诊',
    4: '已就诊',
    5: '待患者确认',
    6: '待修改',
    7: '已过期',
    8: '预约成功',
    9: '预约取消',
    10: '已取号',
    11: '已退号',
    12: '过期失效'
  },
  // 即时工单类型
  INSTANT_ORDER_TYPE: [10, 39, 5]
}
